import { useTranslation } from "react-i18next";
import s from "./styles";
import AlertIcon from "components/icons/AlertIcon";

const NoDataPlaceHolder = ({ height = "200px" }) => {
  const { t } = useTranslation();
  return (
    <s.NoItemsContainer height={height}>
      <s.NoItemsMessageCenter>
        <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
        <s.Title>{t("general.noData")}</s.Title>
      </s.NoItemsMessageCenter>
    </s.NoItemsContainer>
  );
};

export default NoDataPlaceHolder;
